// extracted by mini-css-extract-plugin
export default {"logoContainer":"onBoardingMobile_logoContainer__nkuMA","logo":"onBoardingMobile_logo__9SgsW","actions":"onBoardingMobile_actions__Gb72m","signUp":"onBoardingMobile_signUp__0oj0y"};